import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=3e5fc874"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports